<template>
	<div class="link-pagebar">
		<link-select
			class="link-pagebar-select"
			suffix-icon="link-icon-down"
			hide-clear-icon
			:value="pageSize"
			:size="size"
			:width="width"
			:data="sizeOption"
			:display-format="sizeOptionDisplayFormat"
			:filterable="false"
			@select="pl_selectSizeOption">
			<template slot-scope="{item}">
				<span>{{item}}条/页</span>
			</template>
		</link-select>
		<div class="link-pagebar-operate-wrapper">
            <span class="link-pagebar-operate-num" @click.stop="pl_prevPage">
                <link-icon icon="link-icon-left"/>
            </span>
			<template v-if="showPageNum">
				<template v-if="page-availablePage-2>0">
					<span class="link-pagebar-operate-num" @click.stop="pl_jumpPage(1)">1</span>
					<span class="link-pagebar-operate-num"><link-icon icon="link-icon-ellipsis"/></span>
				</template>
				<span v-for="(item,index) in nums"
					  :key="index"
					  class="link-pagebar-operate-num"
					  :class="{'link-pagebar-operate-num-active':(item-0) === (page-0)}"
					  @click.stop="pl_jumpPage(item)">
                    {{item}}
                </span>
				<template v-if="showLastPageIcon">
					<span class="link-pagebar-operate-num"><link-icon icon="link-icon-ellipsis"/></span>
					<span class="link-pagebar-operate-num" @click.stop="pl_jumpPage(totalPage)">{{totalPage}}</span>
				</template>
			</template>
			<span class="link-pagebar-operate-num" @click.stop="pl_nextPage">
                <link-icon icon="link-icon-right"/>
            </span>
			<!--<link-icon icon="icon-refresh" @click.stop="handleClickRefresh"/>-->
		</div>
		<div class="link-pagebar-input">
			<span>跳至</span><link-input-number :showIcon="false" placeholder="页码" hideClearIcon :width="50" :value="page" @enter.stop="e=>pl_jumpPage(e.target.value)" :min="1" :regexp="/[^0-9]/g"/><span>页</span>
		</div>
	</div>
</template>

<script>
    export default {
        name: "link-pagebar",
        props: {
            showPageNum: {type: Boolean, default: true},                //是否展示页数字以供点击数字跳转
            width: {type: Number, default: 85},                         //页大小下拉框宽度
            size: {type: String, default: 'default'},                   //页大小下拉框大小
            page: {default: 1},                                         //当前页
            pageSize: {type: Number | String, default: '10'},           //当前页大小
            totalSize: {type: Number},                                  //总记录个数，用来计算总页数
            sizeOption: {type: Array},                                  //页大小可选选项
            availablePage: {type: Number, default: 3}                   //页数字左右数字的个数，默认最大为三个，也就是数字最多有七个
        },
        data() {
            return {
                showLastPage: false,
                showLastPageIcon: false
            }
        },
        computed: {
            totalPage() {
                const totalSize = this.totalSize == null ? 0 : this.totalSize
                return Math.ceil(totalSize / this.pageSize);
            },
            nums() {
                if (!this.totalSize) return [];
                const ret = [];

                let begin = this.page - 0 - this.availablePage;
                let end = this.page - 0 + this.availablePage;
                if (begin < 1) {
                    end += 1 - begin;
                    begin = 1;
                }
                if (end < this.totalPage) {
                    this.showLastPage = true;
                } else {
                    end = this.totalPage;
                    this.showLastPage = false;
                }
                this.showLastPageIcon = end !== this.totalPage - 1 && this.showLastPage;
                this.begin = begin;
                this.end = end;

                while (begin <= end) {
                    ret.push(begin);
                    begin++;
                }

                return ret;
            }
        },
        methods: {
            sizeOptionDisplayFormat(data, val) {
                if (data == null || val == null) return null;
                for (let i = 0; i < data.length; i++) {
                    const item = data[i];
                    if (item.value === val) return `${val}条/页`;
                }
                return null;
            },
            pl_selectSizeOption(value) {
                this.$emit('sizeChange', value)
            },
            pl_prevPage() {
                if (this.page === 1) {
                    return
                }
                this.$emit('prevPage', this.page - 1)
            },
            pl_nextPage() {
                if (this.page === this.totalPage) {
                    return
                }
                this.$emit('nextPage', this.page + 1)
            },
            pl_jumpPage(page) {
                this.$emit('jumpPage', page)
            },
        }
    }
</script>

<style lang="scss">
	@include themeify {
		.link-pagebar {
			display: flex;
			align-items: center;
			height: 28px;
			font-size: 12px;

			.link-pagebar-operate-num {
				min-width: 28px;
				height: 28px;
				line-height: 28px;
				border: solid 1px pl-var(color-info);
				box-sizing: border-box;
				color: rgba(0,0,0,0.65);
			}

			.link-pagebar-operate-wrapper {
				display: inline-flex;
				align-items: center;
				padding-left: 12px;
				padding-right: 4px;
				box-sizing: border-box;

				.link-icon, .link-pagebar-operate-num {
					cursor: pointer;
					margin: 0 4px;
					font-size: inherit;
				}

				.link-pagebar-operate-num {
					display: inline-block;
					text-align: center;
					user-select: none;

					&.link-pagebar-operate-num-active {
						background-color: pl-var(color-primary);
						color: white;
						border-color: pl-var(color-primary);
					}

					&:active {
						background-color: pl-var(color-primary-light);
					}
				}
			}

			.link-pagebar-input {
				display: inline-flex;
				align-items: center;

				.link-input {
					margin: 0 8px;

					input {
						text-align: center;
						padding: 0;
					}
				}

			}

		}
	}
</style>
